import { KoButton, KoToast } from "packages";
import KoIcon from "@kwapio/icons";
import styles from "../feed.module.scss";
import { FeedAPI } from "../feed.service";

export default function FeedActions({ post, getFeeds, onCommentClick }) {
  const toggleLike = () => {
    const upd = {
      like: !post.likedByMe
    };

    getFeeds && getFeeds();
    FeedAPI.postLike(upd, post.feedId).catch(() => { });
  };

  const savePost = () => {
    const upd = {
      save: !post.savedByMe
    };

    getFeeds && getFeeds();
    FeedAPI.postSave(upd, post.feedId).catch(() => { });
  };

  const sharePost = (feedId) => {
    FeedAPI.shareFeedLink(feedId).then((res) => {
      navigator.clipboard.writeText(res.publicUrl);
      KoToast.success("Feed link copied please share");
    }).catch(() => {
      KoToast.error("Failed to copy feed link");
    });
  };

  return (
    <div className={styles.actions}>
      <div className={styles.actionsLeft}>
        <KoButton
          type="text"
          label={post.likesCount || 0}
          onClick={toggleLike}
          className={styles.likeBtn}
          icon={
            <KoIcon
              width={18}
              height={18}
              name="HeartOutlined"
              color={post.likedByMe ? "red" : "var(--palette-gray-7)"}
            />
          }
        />

        <KoButton
          type="text"
          label={post.comments?.length || 0}
          onClick={onCommentClick}
          icon={<KoIcon width={18} height={18} name="ChatOutlined" />}
        />

        <KoButton
          onClick={() => {sharePost(post.feedId);}}
          type="text"
          icon={<KoIcon width={16} height={16} name="ShareOutlined" />}
        />
      </div>
      <div className={styles.actionsRight}>
        <KoButton
          type="text"
          className={post.savedByMe ? styles.saveBtn : ''}
          onClick={savePost}
          icon={<KoIcon width={18} height={18} name="BookMarkOutlined" color='red' />}
        />
      </div>
    </div>
  );
}
